// CallButton.js
import React, { useState } from "react";
import { CopyOutlined } from '@ant-design/icons'; // FileDoneOutlined
import { message } from "antd"; // Button
import PropTypes from "prop-types";
import FeatherIcon from 'feather-icons-react';

function CopyButton({ apiKey, type }) {
    const [copied, setCopied] = useState(false);
    if (!apiKey || apiKey === "") return null;

    const copyToClipboard = async () => {
        if (copied) return;
        try {
            await navigator.clipboard.writeText(apiKey);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 3000);
            message.success(`${type} copied`);
        } catch {
            message.error(`Failed to copy ${type}`);
        }
        // navigator.clipboard.writeText(apiKey).then(() => {
        //     message.success(`${type} copied to clipboard`);
        // }).catch(() => {
        //     message.error(`Failed to copy ${type}`);
        // });
    };
    return (
        <div className='Hover-Refresh2 back-hover1 able-style'
            role="button"
            tabIndex={0} title='Copy' style={{ marginLeft: (type === "Email" || type === "URL") ? 5 : 0 }}
            onClick={() => copyToClipboard()}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    copyToClipboard()
                }
            }}
            aria-label='copy key'
        >  {copied ? (
            <FeatherIcon size={16} icon="check" />
            // <FileDoneOutlined style={{ color: "#52c41a" }} />
        ) : (
            <CopyOutlined />
        )}</div>
    );
}
CopyButton.propTypes = {
    apiKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default CopyButton;
